export default __webpack_public_path__ + "static/media/chameleon.316f54cb.jpeg";